import axios from 'axios'
import { pdfEndPoint } from '../constants/constants'
import { Text } from '../constants/TextConstants'

const baseURL = process.env.REACT_APP_DEV_URL_BE

export const client = axios.create({ baseURL })

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error)) {
      // NOTE: checks for jwt expiring
      if (error.response.data.error === 'jwt expired') {
        window.location.replace(process.env.REACT_APP_DEV_URL)
      }

      throw new Error(error.message)
    }

    throw new Error(Text.UnexpectedErrorOccured)
  }
)

async function CreateRole(role, token) {
  const { data } = await client.post(
    '/role/createRole',
    {
      data: role
    },
    { headers: { Authorization: token } }
  )
  return data
}

async function UpdateRole(role, token) {
  const { data } = await client.put(
    '/role/updateRole',
    {
      data: role
    },
    { headers: { Authorization: token } }
  )

  return data
}

async function GetUsersProfile(email, token) {
  const { data } = await client.get('/profile/getUsersProfile', {
    headers: { email: email, Authorization: token }
  })

  return data
}

async function GetRole(idRole, token) {
  const { data } = await client.get('/role/getRole', {
    headers: { id: idRole, Authorization: token }
  })

  return data
}

async function DeleteRole(idRole, token) {
  const { data } = await client.delete('/role/deleteRole', {
    headers: { id: idRole, Authorization: token }
  })

  return data
}

async function GetRoles() {
  const { data } = await client.get('/role/getRoles')

  return data
}

async function GetPermissions(token) {
  const { data } = await client.get('/permission/getPermissions', {
    headers: { Authorization: token }
  })

  return data
}
async function GetUserPermissions(token) {
  const { data } = await client.get('/permission/getUserPermissions', {
    headers: { Authorization: token }
  })

  return data
}

async function GetMaxPermissionsAmount(token) {
  const { data } = await client.get('/permission/getMaxPermissionsAmount', {
    headers: { Authorization: token }
  })

  return data
}

async function GetOwnProfile(token) {
  const { data } = await client.get('/profile/getProfile', {
    headers: { Authorization: token }
  })

  return data
}

async function updateUserSettings(settings, token) {
  const { data } = await client.put(
    '/profile/updateUserConfig',
    {
      data: {
        filters: settings
      }
    },
    {
      headers: { Authorization: token }
    }
  )

  return data
}

async function PostProfile(data) {
  const response = await client.post(pdfEndPoint, data)

  return response.data
}

async function Login(token) {
  const bearer = `${token}`

  const { data } = await client.get('/login', {
    headers: { Authorization: bearer, 'Access-Control-Allow-Origin': 'http://localhost' }
  })

  return data
}

async function CreateProfile(profile, Email, token) {
  const { data } = await client.put(
    '/profile/editProfile',
    {
      data: profile
    },
    { headers: { email: Email, Authorization: token } }
  )

  return data
}

async function CreateProfileImage(uploadedImage, Email, token) {
  const bodyFormData = new FormData()
  bodyFormData.append('profileImage', uploadedImage)
  const { data } = await client.put('/profile/editProfileImage', bodyFormData, {
    headers: { email: Email, Authorization: token }
  })

  return data
}

async function GetProfileLogs(profileEmail) {
  const data = await client.get(`/profile/getProfileLogs?email=${profileEmail}`)

  return data
}

async function UpdateProfile(token) {
  const { data } = await client.get('/eis/updateProfile', { headers: { Authorization: token } })

  return data
}

async function GetSkills(skillClass, token) {
  const { data } = await client.get('/skill', {
    headers: { Authorization: token, skill: skillClass }
  })

  return data
}

async function UpdateSkills(skillClass, oldSkillValue, newSkillValue, token) {
  const { data } = await client.put(
    '/skill',
    {
      data: {
        skill: skillClass,
        oldSkill: oldSkillValue,
        newSkill: newSkillValue
      }
    },
    {
      headers: { Authorization: token, skill: skillClass }
    }
  )

  return data
}

async function GetProfiles(actualPage, pageSize, sort, filters, status = 'active') {
  const { data } = await client.get(
    `/profile/getProfiles?status=${status}&page=${actualPage}&pageSize=${pageSize}&sortBy=${JSON.stringify(
      sort
    )}&filters=${encodeURIComponent(JSON.stringify(filters))}`
  )

  return data
}

async function GetOptions(options) {
  const { data } = await client.get(
    !options ? '/options' : `/options?type=${encodeURIComponent(JSON.stringify(options))}`
  )

  return data
}

async function CreateSkill(skillType, skillName, token) {
  const { data } = await client.post(
    '/skill',
    {
      data: {
        skill: skillType,
        values: [skillName]
      }
    },
    {
      headers: { Authorization: token }
    }
  )

  return data
}

async function DeleteSkill(skillType, skillName, token) {
  const { data } = await client.patch(
    '/skill',
    {
      data: {
        skill: skillType,
        values: Array.isArray(skillName) ? [...skillName] : [skillName]
      }
    },
    {
      headers: { Authorization: token }
    }
  )

  return data
}

async function DeleteProfile(email, token) {
  const { data } = await client.put(
    '/deleteprofile',
    {
      data: {
        emails: [email]
      }
    },
    {
      headers: { Authorization: token }
    }
  )

  return data
}

async function updateUserRole(userRole, email) {
  const { data } = await client.put('/profile/updateUserRole', { data: { email, userRole } })

  return data
}

async function updateRoleAccess(roleAccessLimits, email) {
  const { data } = await client.put('/role/updateRoleAccess', { email, ...roleAccessLimits })

  return data
}

async function GetSupportEmails(token) {
  const { data } = await client.get('/resource/support', { headers: { Authorization: token } })

  return data
}

async function UpdateSupportEmails(email, type, token) {
  const { data } = await client.put(
    '/resource/support',
    {
      data: {
        email: email,
        type: type
      }
    },
    {
      headers: { Authorization: token }
    }
  )

  return data
}

async function GetTemplateList(token) {
  const { data } = await client.get('/template', { headers: { Authorization: token } })

  return data
}

async function GetTemplate(token, id, email, isAdmin = false, isAnonymyzedTemplate = false, exportScaleLevels = false) {
  const { data } = await client.get(`/template?id=${id}`, {
    headers: { Authorization: token, email },
    params: {
      isAdmin,
      isAnonymyzedTemplate,
      exportScaleLevels
    }
  })

  return data
}

async function GetTemplates(
  token,
  id,
  email,
  userEmails,
  exceptOf,
  filters,
  isAdmin = false,
  isAnonymyzedTemplate = false,
  exportScaleLevels = false,
  format
) {
  const userEmailsJoined = typeof userEmails === 'string' ? userEmails : userEmails.join(',')
  const exceptOfJoined = exceptOf.join(',')
  const params = {
    isAdmin,
    isAnonymyzedTemplate,
    exportScaleLevels,
    format,
    userEmails: userEmailsJoined,
    exceptOf: exceptOf.length > 0 ? exceptOfJoined : null,
    ...(Object.keys(filters).length !== 0 && { filters: encodeURIComponent(JSON.stringify(filters)) })
  }
  const data = await client.get(`/template?id=${id}`, {
    headers: { Authorization: token, email },
    params
  })

  return data
}

async function CreateTemplate(template, Email, token) {
  if (template.id) {
    const { data } = await client.put('/template', template, { headers: { email: Email, Authorization: token } })

    return data
  } else {
    const { data } = await client.post('/template', template, { headers: { email: Email, Authorization: token } })

    return data
  }
}

async function DeleteTemplate(template, token) {
  const { data } = await client.patch(`/template?id=${template._id}`, { headers: { Authorization: token } })

  return data
}

async function GetSpellErrors(text, token) {
  const { data } = await client.post(
    '/spellcheck/getErrorPercentage',
    {
      text: text
    },
    { headers: { Authorization: token } }
  )

  return data
}

async function GetRegions() {
  const { data } = await client.get('/regions')

  return data
}

async function GetDisciplines() {
  const { data } = await client.get('/disciplines')

  return data
}

export const epagAPI = {
  GetUsersProfile,
  GetOwnProfile,
  PostProfile,
  CreateProfile,
  CreateProfileImage,
  GetSkills,
  CreateSkill,
  UpdateSkills,
  DeleteSkill,
  DeleteProfile,
  GetSupportEmails,
  UpdateSupportEmails,
  GetTemplateList,
  GetTemplate,
  GetTemplates,
  CreateTemplate,
  DeleteTemplate,
  Login,
  GetProfiles,
  GetOptions,
  GetSpellErrors,
  updateUserSettings,
  UpdateProfile,
  GetRoles,
  GetPermissions,
  CreateRole,
  UpdateRole,
  GetRole,
  DeleteRole,
  updateUserRole,
  updateRoleAccess,
  GetUserPermissions,
  GetMaxPermissionsAmount,
  GetRegions,
  GetDisciplines,
  GetProfileLogs
}
